import { Grid } from "@material-ui/core";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import { makeStyles } from "@saleor/macaw-ui";
import React, { memo } from "react";

import {
  AddAlternatedProvider,
  useAddAltermatedMaterial
} from "./AddAlternatedContext";
import AddItem from "./AddItem";
import BottomBar from "./BottomBar";
const useStyles = makeStyles(
  () => ({
    boxContainer: {
      paddingBottom: "20rem"
    },
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        margin: 0,
        marginBottom: "1.2rem"
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    }
  }),
  { name: "AlternatedMaterialView" }
);

const AddAlternatedMaterialComponent: React.FC<any> = () => {
  const classes = useStyles();

  const { listOrganization } = useAddAltermatedMaterial();

  return (
    <>
      <Container className={classes.boxContainer}>
        <PageHeader
          className={classes.pageHeader}
          title={"Add Master"}
          subTitle={" - Alternated Material"}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <AddItem listOrganization={listOrganization} />
          </Grid>
        </Grid>
        <BottomBar />
      </Container>
    </>
  );
};

const AddAlternatedMaterial = () => (
  <AddAlternatedProvider>
    <AddAlternatedMaterialComponent />
  </AddAlternatedProvider>
);

export default memo(AddAlternatedMaterial);
